import { render, staticRenderFns } from "./DialogDnsQuickConnext.vue?vue&type=template&id=3140d9bc&"
import script from "./DialogDnsQuickConnext.vue?vue&type=script&lang=js&"
export * from "./DialogDnsQuickConnext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports